const getVideoDurationFromFile = async (
  file: File | Blob,
  fallbackTimeout?: number
): Promise<number> => new Promise(resolve => {
  const video = document.createElement("video");
  const estimatedDuration = () => Math.max(1, file.size / (1024 * 1024));

  let timeoutId: any;
  if (fallbackTimeout) {
    timeoutId = setTimeout(() => {
      URL.revokeObjectURL(video.src);
      resolve(estimatedDuration());
    }, fallbackTimeout);
  }

  video.onloadedmetadata = () => {
    clearTimeout(timeoutId);

    if (video.duration === Infinity) {
      video.ontimeupdate = () => {
        video.ontimeupdate = null;
        video.currentTime = 0;
        resolve(video.duration);
        URL.revokeObjectURL(video.src);
      };
      video.currentTime = Number.MAX_SAFE_INTEGER;
      return;
    }

    resolve(video.duration);
    URL.revokeObjectURL(video.src);
  };

  video.onerror = () => {
    clearTimeout(timeoutId);
    URL.revokeObjectURL(video.src);
    resolve(estimatedDuration());
  };

  video.src = URL.createObjectURL(file);
  video.crossOrigin = "anonymous";
  video.preload = "metadata";
});

export default getVideoDurationFromFile;
